/****************************************************
App.tsx - Root Page of the application
*****************************************************/
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from "./components/pages/Layout";

const App = () => {
 
  return (
    <><React.Fragment>
      <Layout></Layout>

    </React.Fragment>

    </>
  );
};
export default App;
